module.exports = __webpack_public_path__ + "static/media/5.5d65599d.jpg";